import { isQuizPin, TeacherPin } from '@lessonup/pins-shared';
import { inputPinPhases } from '../../../store/playerStore.types';
import { nextPhase } from '../../../store/reducers/reducers.utils';
import { SelfPacedQuizView } from '../../store/selfPacedPlayerStore.types';
import { SelfPacedPinReducer } from '../selfPacedReducer.types';

export const multipleChoiceReducer: SelfPacedPinReducer<SelfPacedQuizView> = {
  phases: inputPinPhases,
  initial: (state, history) => {
    const pin = state.pins.find((p) => p.id === state.currentPinId);

    if (history) {
      return history;
    }

    return { type: 'MULTIPLE_CHOICE', phase: hasCorrectAnswers(pin) ? 'input' : 'results' };
  },
  hasNextView: (state, currentView, direction) => {
    const pin = state.pins.find((p) => p.id === state.currentPinId);

    if (!hasCorrectAnswers(pin)) return false;
    return nextPhase(currentView.phase, inputPinPhases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    const pin = state.pins.find((p) => p.id === state.currentPinId);

    if (!hasCorrectAnswers(pin)) return false;
    const next = nextPhase(prev.phase, inputPinPhases, direction);
    return next ? { type: 'MULTIPLE_CHOICE', phase: next } : false;
  },
  hasCorrectAnswers: (state) => {
    const pin = state.pins.find((p) => p.id === state.currentPinId);
    return !!hasCorrectAnswers(pin);
  },
};

function hasCorrectAnswers(pin?: TeacherPin): boolean {
  const correctAnswers = getCorrectAnswersFromPin(pin);
  return !!correctAnswers?.length;
}

function getCorrectAnswersFromPin(pin?: TeacherPin) {
  if (!pin || !isQuizPin(pin)) return null;
  return pin.teacherSettings.correctAnswers;
}
